/** Persisted showcase state - maps showcase name to whether it has been seen */
export type PersistedShowcaseState = Record<string, boolean>;

export const DefaultShowcasesConfig: {
  seenShowcases: PersistedShowcaseState;
} = {
  seenShowcases: {},
};
